import { useMainContext } from "../../../../context";
import { MaskCPF, MaskPhone } from "../../../../utils/masks";
import { useCartContext } from "../../context";
import InputLabel from "../../../../components/inputLabel";
import { useCallback } from "react";

const CartUserInfo = () => {
  const { order, setOrder } = useMainContext();
  const { changePhone, changeName } = useCartContext();

  const handleCpfChange = useCallback(
    (text) => {
      const newCpf = MaskCPF(text);

      setOrder((atualOrder) => {
        if (atualOrder) {
          return { ...atualOrder, cpf: newCpf };
        }
        return atualOrder;
      });
    },
    [setOrder],
  );

  const handleCpfInNoteChange = useCallback(
    (value) => {
      setOrder((atualOrder) => {
        if (atualOrder) {
          return { ...atualOrder, cpfInNote: value };
        }

        return atualOrder;
      });
    },
    [setOrder],
  );

  return (
    <div className="flex flex-1 flex-col border-2 border-gray-200 rounded-xl p-4 shadow-sm">
      <h4 className="font-bold text-lg mb-4 break-words">DADOS PESSOAIS</h4>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <InputLabel
          label="Nome"
          placeholder="Insira seu nome"
          maxLength={100}
          value={order.name}
          onChange={(event) => changeName(event.target.value)}
        />

        {order.withdrawal !== "balcony" && (
          <>
            <InputLabel
              label="Telefone para contato"
              placeholder="(00) 00000-0000"
              maxLength={15}
              value={order.phone ? MaskPhone(order.phone) : ""}
              onChange={(event) => changePhone(event.target.value)}
            />

            <div className="md:col-span-2">
              {order.cpfInNote && (
                <InputLabel
                  label="CPF"
                  placeholder="000.000.000-00"
                  maxLength={14}
                  value={order.cpf ? MaskCPF(order.cpf) : ""}
                  containerClass="mb-3"
                  onChange={(event) => handleCpfChange(event.target.value)}
                />
              )}

              <label className="cursor-pointer flex items-center">
                <input
                  onChange={(event) => handleCpfInNoteChange(!order.cpfInNote)}
                  type="checkbox"
                  checked={order.cpfInNote ? true : false}
                  className="hidden peer"
                />

                <div className="w-5 h-5 mr-3 border-2 rounded border-gray-400 peer-checked:bg-primary-500 peer-checked:border-primary-500 flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M5 13l4 4L19 7" />
                  </svg>
                </div>

                <span className="text-md">CPF na nota?</span>
              </label>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CartUserInfo;
